var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    rx: 16,
    fill: "#8B8B8B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7592 17.5514C52.5575 17.3932 52.28 17.3733 52.0577 17.501C51.0038 18.1068 49.8898 18.4141 48.7467 18.4141C45.0738 18.4141 42.0858 15.4259 42.0858 11.7529C42.0858 10.6048 42.3934 9.49231 43.0002 8.44647C43.1291 8.22444 43.11 7.94632 42.9519 7.74391C42.794 7.5415 42.5287 7.45539 42.2821 7.52666C40.5078 8.03813 38.9108 9.12329 37.7854 10.5822C36.6174 12.0964 36 13.9098 36 15.8266C36 20.6089 39.8905 24.4997 44.6727 24.4997C46.5895 24.4997 48.4034 23.8825 49.9183 22.7149C51.3782 21.5897 52.4639 19.9937 52.9754 18.2206C53.0465 17.9743 52.9609 17.7096 52.7592 17.5514ZM44.6727 23.2419C40.5841 23.2419 37.2577 19.9154 37.2577 15.8266C37.2577 13.0682 38.8362 10.5579 41.2351 9.29635C40.9645 10.0917 40.8281 10.9133 40.8281 11.7529C40.8281 16.1194 44.3804 19.6718 48.7467 19.6718C49.5851 19.6718 50.4082 19.5348 51.2073 19.2632C49.9459 21.6627 47.4335 23.2419 44.6727 23.2419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeLightIcon);
export default __webpack_public_path__ + "static/media/mode-light-icon.ee724cf6178e61d88e9693bbd4e3ced7.svg";
export { ForwardRef as ReactComponent };